import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getProductSales, getCsvReport } from 'actions/ReportsAction';
import { getProductCategories, resetProductCategories, clearProductList } from 'actions/EntityActions';
import { formInput, clearFormInput, clearDialogItemsProductGroup } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportProductSalesCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from '../DateCurrentDisplay';

const componentName = "ProductSales";

class ProductSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            totalRow: 0,
            showBody: false,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0,
                category: '',
                employeeName: ''
            },
            showCategorySummary: false
        };
        this.getBranchInfo = this.getBranches.bind(this);
        this.showBody = this.showBody.bind(this)
        this.calculateMargin = this.calculateMargin.bind(this);
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `ProductSalesBeginDate`)
        this.props.formInput(date, `ProductSalesEndDate`)
        this.props.formInput(0, `ProductSalesProductId`);
        this.props.getProductCategories(this.props.branchId || parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')));
        if (localStorage.getItem("ProductSalesBranchIds") != null) {
            this.props.formInput(localStorage.getItem("ProductSalesBranchIds").split(","), "ProductSalesBranchIds")
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedBranchIds != undefined && this.props.selectedBranchIds != prevProps.selectedBranchIds) {
            localStorage.setItem("ProductSalesBranchIds", this.props.selectedBranchIds)
        }
    }

    componentWillUnmount() {
        this.props.resetProductCategories();
        this.props.clearProductList();
    }

    getEmployeeOptions = () => {
        return (this.props.employees || []).map(item => {
            return {
                text: `${item.firstName} ${item.lastName}`,
                value: item.id.toString()
            };
        });
    }

    getCategoryOptions = () => {
        return (this.props.category.list || []).map(item => {
            return {
                text: item.name,
                value: item.id.toString(),
                isCannabis: item.isCannabis
            };
        });
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.selectedBranches ? this.props.selectedBranches : this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let category = this.props.categoryFilter || 0;
        let employee = this.props.employeeFilter || 0;
        let productid = this.props.selectProductId || 0;
        let weightFilter = parseFloat(this.props.weightFilter) || 0;
        let isCannabis = this.props.isCannabis;
        let brandName = this.props.ProductSalesBrandName || '';
        this.props.getProductSales({ beginDate, endDate, branchIds, category, employee, pageNumber, pageSize, productid, weightFilter, isCannabis, brandName });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.selectedBranches ? this.props.selectedBranches : this.props.loggedBranch;
        let pageNumber = 1;
        let pageSize = 9999999;
        let category = this.props.categoryFilter || 0;
        let employee = this.props.employeeFilter || 0;
        let productid = this.props.selectProductId || 0;
        let weightFilter = parseFloat(this.props.weightFilter) || 0;
        let isCannabis = this.props.isCannabis;
        let brandName = this.props.ProductSalesBrandName || '';
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/productsales?beginDate=${beginDate}&endDate=${endDate}&category=${category}&weightFilter=${weightFilter}&productid=${productid}&employeeId=${employee}&pageNumber=${pageNumber}&pageSize=${pageSize}&branchIds=${branchIds}&isCannabis=${isCannabis}&brandName=${brandName}`, "productsales");
        }
    }

    cleanSearch = () => {
        this.props.clearFormInput(`ProductSalesEmployeeName`);
        this.props.clearFormInput(`ProductSalesCategoryOption`);
        this.props.clearFormInput(`ProductSalesEndDate`);
        this.props.clearFormInput(`ProductSalesBeginDate`);
        this.props.clearFormInput(`ProductSalesBranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    clearFilter = () => {
        this.props.clearFormInput(`ProductSalesEmployeeName`);
        this.props.clearFormInput(`ProductSalesCategoryOption`);
        this.props.clearFormInput(`ProductSalesEndDate`);
        this.props.clearFormInput(`ProductSalesBeginDate`);
        this.props.clearFormInput(`ProductSalesBrandName`);
        this.props.clearFormInput(`ProductSalesIsCannabis`);
        this.props.clearFormInput(`ProductSalesWeight`);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    getProductOptions = () => {
        return (this.props.products || []).map(item => {
            return {
                text: item.name,
                value: item.id,
                categoryId: item.categoryId
            };
        });
    }
    calculateMargin(revenue, basePrice, quantity) {
        const totalCost = basePrice * quantity;
        const margin = (revenue - totalCost) / revenue;

        return margin * 100;
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else if (this.props.ProductSalesBrandName != null && this.props.ProductSalesBrandName != "" && this.props.ProductSalesBrandName.length < 3) {
            this.props.showError(LOOKUP.report.common.brandNameError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    handleShowCategorySummary = () => {
        this.setState({ showCategorySummary: !this.state.showCategorySummary })
    }

    getBranches() {
        const selectedBranches = this.props.selectedBranches ? [...this.props.selectedBranches] : [];
        const allBranches = this.props.branches ? [...this.props.branches] : [];

        if (this.props.selectedBranches && selectedBranches.length === 0) {
            return selectedBranches;
        }
        if (selectedBranches.length > 0) {

            const userSelectedBranches = allBranches.filter(item => selectedBranches.includes(item.id.toString())).map(item => { return { id: item.id, name: item.name } })
            return userSelectedBranches;
        }
        return allBranches.map(b => ({ id: b.id, name: b.name }));
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.productSales && newProps.productSales.list && newProps.productSales.list.length > 0 ? newProps.productSales.list[0].totalrow : 0;
            this.setState({ totalRow: totalRow })
        }
    }

    render() {
        return (
            <Grid headerContent={reportProductSalesCrumb}>
                <PageHeader
                    title={LOOKUP.report.productSales.text}
                    description={LOOKUP.report.productSales.description}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-product-sales-report" />}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    employeeOptions={this.getEmployeeOptions()}
                    weightOptions={this.props.weightOptions}
                    productCategories={this.getCategoryOptions()}
                    isCannabisOptions={this.props.isCannabisOptions}
                    isCannabis={this.props.isCannabis}
                    filter={this.filter}
                    download={this.downloadReport}
                    clearFilter={this.clearFilter}
                    showBody={this.showBody}
                    products={this.getProductOptions()}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody && this.props.productSales && 
                    <CardSimple>
                        <Body
                            productSales={this.props.productSales}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            calculateMargin={this.calculateMargin}
                            handleShowCategorySummary={this.handleShowCategorySummary}
                            showCategorySummary={this.state.showCategorySummary}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );

    }
}

const mapStateToProps = state => {

    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let weightOptions = [
        {
            text: "All", value: "0"
        },
        {
            text: "1G", value: "1"
        },
        {
            text: "3.5G", value: "3.5"
        },
        {
            text: "7G", value: "7"
        },
        {
            text: "14G", value: "14"
        },
        {
            text: "28G", value: "28"
        }
    ];
    let isCannabis = [
        {
            text: "All", value: "2"
        },
        {
            text: "Cannabis", value: "1"
        },
        {
            text: "Non-Cannabis", value: "0"
        }
    ];

    return {
        brachOptions: brachOptions,
        weightOptions: weightOptions,
        isCannabisOptions: isCannabis,
        isCannabis: state.form.ProductSalesIsCannabis,
        ProductSalesBrandName: state.form.ProductSalesBrandName,
        productSales: state.reports.productSales,
        loggedBranch: state.common.branchId,
        category: state.entity.productCategories,
        employees: state.entity.employeeList,
        branch: state.form.ProductSalesBranchOption,
        beginDate: state.form.ProductSalesBeginDate,
        endDate: state.form.ProductSalesEndDate,
        categoryFilter: state.form.ProductSalesCategoryOption,
        selectProductId: state.form.ProductSalesProductId,
        products: state.entity.productList,
        employeeFilter: state.form.ProductSalesEmployeeName,
        weightFilter: state.form.ProductSalesWeight,
        selectedBranches: state.form.ProductSalesBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getProductSales: model => dispatch(getProductSales(model)),
        getProductCategories: (branchId) => dispatch(getProductCategories(branchId)),
        resetProductCategories: () => dispatch(resetProductCategories()),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        clearProductList: () => dispatch(clearProductList()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ProductSales));